import { render, staticRenderFns } from "./MyQuotationCommentList.vue?vue&type=template&id=2f9af2f2&scoped=true&"
import script from "./MyQuotationCommentList.vue?vue&type=script&lang=js&"
export * from "./MyQuotationCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9af2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9af2f2')) {
      api.createRecord('2f9af2f2', component.options)
    } else {
      api.reload('2f9af2f2', component.options)
    }
    module.hot.accept("./MyQuotationCommentList.vue?vue&type=template&id=2f9af2f2&scoped=true&", function () {
      api.rerender('2f9af2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationCommentList.vue"
export default component.exports